module.exports = __webpack_public_path__ + "img/1648_c.29d8a585.png";